<div class="requirements-component">
  <app-table
    (sortColumn)="sortColumn($event)"
    (filterColumn)="getRequirementsFilteredByName($event)"
    (toggleActiveList)="toggleActiveList($event)"
    (addNewItem)="addNewRequirement()"
    (showEditModal)="showEditModal($event)"
    (showItemDetails)="showItemDetails($event)"
    (paginationEvent)="paginationEvent($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
    (pageChanged)="onPageChanged($event)"
    [tableData]="tableData"
    [hideIcon]="true"
    [isLoading]="loading"
  >
  </app-table>
  <app-loading-spinner class="spinner" *ngIf="loading"></app-loading-spinner>
</div>
